var map = {
	"./app/zhCHT/about-us.jpg": "d3d9",
	"./app/zhEn/about-us.jpg": "a656",
	"./pc/zhCHT/about-us.jpg": "7477",
	"./pc/zhEn/about-us.jpg": "e158"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d024";